<template>
  <ZmButton
    :class="{ 'is-round': round }"
    v-bind="buttonAttrs"
  >
    <slot />
  </ZmButton>
</template>

<script setup>
import { computed, useAttrs } from 'vue';
import { ZmButton } from '@zoom/zoom-ui-vue3';

defineOptions({ inheritAttrs: false });

// Define props
defineProps({
  round: {
    type: Boolean,
    default: false
  }
});

// Map type="link" to type="text"
const attrs = useAttrs();
const buttonAttrs = computed(() => {
  const buttonProps = { ...attrs };
  if (buttonProps.type === 'link') {
    buttonProps.type = 'text';
  }
  return buttonProps;
});
</script>


